export enum EEditReminderOptions {
  SINGLE = 'single',
  SERIES = 'series',
  THIS_AND_FUTURE = 'thisAndFuture',
}
